import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Breadcrumb } from 'react-breadcrumbs'
import { useHistory, useRouteMatch } from 'react-router-dom'

import { Breadcrumbs } from 'Components/Breadcrumbs/index'
import { ClientAddWrapper } from 'Components/Clients/ClientAdd/ClientAddWrapper'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { createClient, updateClientById } from 'Reducers/Clients/actions'
import { uploadClientImage } from 'Reducers/Upload/actions'
import ClientsIcon from 'Assets/Images/icons/clients'
import { PATHS } from 'Config/Routing/paths'
import ClientForm from '../ClientForm'
import { CLIENT_FORM_MODES } from '../const'
import useGraphQLFetch from '../../../Utils/Hooks/useGraphQLFetch'
import { getTagsGQL } from './gql'
import { createClientTagLinkGQL } from '../gql'

const BreadcrumbsClientAdd = ({ currentPath }) => (
  <div>
    <Breadcrumbs icon={<ClientsIcon style={{ width: 24 }} />} />
    <Breadcrumb
      data={{
        title: 'Clients',
        pathname: `${PATHS.main.dashboard}${PATHS.dashboard.clients}`,
      }}
    />
    <Breadcrumb
      data={{
        title: 'Add',
        pathname: currentPath,
      }}
    />
  </div>
)

const ClientAdd = () => {
  const match = useRouteMatch()
  const history = useHistory()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [allTags, setAllTags] = useState(null)

  const { data, isLoaded } = useGraphQLFetch({
    fetchFn: getTagsGQL,
    mapResponse: data => data.getTags.edges.map(item => item.node),
  })

  useEffect(() => {
    if (isLoaded) {
      setAllTags(data)
    }
  }, [isLoaded])

  const navigateBack = () => {
    history.push(`${PATHS.main.dashboard}${PATHS.dashboard.clients}`)
  }

  const callbackNavigateBack = {
    onSuccess: navigateBack,
  }

  const handleUpdateLogoAndNavigateBack = ({ id }, logo) => {
    const callbackUpdateClient = {
      onSuccess: imageUrl => {
        dispatch(updateClientById(callbackNavigateBack, id, { logo: imageUrl }))
      },
    }
    dispatch(uploadClientImage(id, logo, callbackUpdateClient))
  }

  const handleCreateTagLinks = async ({ id }, createdTagLinksIds) => {
    if (createdTagLinksIds.length !== 0) {
      await createClientTagLinkGQL({
        tagIds: createdTagLinksIds,
        clientId: id,
      })
    }
  }

  const handleClientAddFormSubmit = async (
    { name, code, tags },
    isValid,
    logo,
  ) => {
    if (isValid) {
      setLoading(true)
      const payload = {
        code: code.value,
        name: name.value,
      }
      const createdTagLinksIds = tags.value.map(item => item.id)

      const callbackCreateTagLinksAndNavigateBack = {
        onSuccess: res => {
          handleCreateTagLinks(res, createdTagLinksIds)
          navigateBack()
        },
      }
      if (logo) {
        const callbackUpdateLogoAndCreateTagLinks = {
          onSuccess: res => {
            handleCreateTagLinks(res, createdTagLinksIds)
            handleUpdateLogoAndNavigateBack(res, logo)
          },
        }
        dispatch(createClient(callbackUpdateLogoAndCreateTagLinks, payload))
      } else {
        dispatch(createClient(callbackCreateTagLinksAndNavigateBack, payload))
      }
      setLoading(false)
    }
  }
  return (
    <LayoutDashboard>
      <ClientAddWrapper>
        <BreadcrumbsClientAdd currentPath={match.url} />
        {allTags && (
          <ClientForm
            handleSubmit={handleClientAddFormSubmit}
            mode={CLIENT_FORM_MODES.ADD}
            buttonsDisabled={loading}
            handleCancel={navigateBack}
            tags={allTags}
          />
        )}
      </ClientAddWrapper>
    </LayoutDashboard>
  )
}

export default ClientAdd



// WEBPACK FOOTER //
// ./src/Containers/Clients/ClientAdd/index.js